import { Box, Button, Modal, Text } from '@mantine/core'

interface BatchPrintConfirmationProps {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
  count: number
  entityType: string
}

export function BatchPrintConfirmation({ opened, onClose, onConfirm, count, entityType }: BatchPrintConfirmationProps) {
  return (
    <Modal opened={opened} onClose={onClose} title="Batch Print Confirmation" centered>
      <Text mb="md">
        You are about to print {count} {entityType} badges. This may take some time to process. Are you sure you want to continue?
      </Text>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }} mt="md">
        <Button variant="outline" onClick={onClose} mr="sm">
          Cancel
        </Button>
        <Button color="custom-primary-color.0" onClick={onConfirm}>
          Continue
        </Button>
      </Box>
    </Modal>
  )
}
